import styled from 'styled-components';
import { DefaultParagraphLargeFactory } from '../Typograph/Typograph.Style';

export const BackNavigationButtonSection = styled.div(({theme, isPadding}) => ({
    display: "flex",
    marginBottom: "0 !important",
    alignItems: "center",
    cursor: "pointer",
    padding: isPadding ? '40px 20px 0 20px' : "",
    background: theme.color.neutral["08"],

    [theme.breakpoint.lg()]: {
        padding: isPadding ? '60px 112px 0 112px' : "",
    }
}))

export const BackNavigationText = styled.p(({ theme }) => ({
    ...DefaultParagraphLargeFactory({theme}),
    color: theme.color.brandPrimary.light
}))

export const BackNavigationIcon = styled.div(() => ({
    display: "flex",
    transform: "rotateY(180deg)",
    alignItems: "center",
}))

export const BackNavigationButtonContent = styled.a(({ theme }) => ({
    display: "flex",
    gap: "16px",
    color: theme.color.brandPrimary.light
}))

